export default "__VITE_PUBLIC_ASSET__7c079b79__"